import { Layer } from "../../framework/layer/Layer";
import { ReplicatedLockRecord } from "../server/ReplicatedLock";
export class GameContext extends Layer {
    constructor(props) {
        super([]);
        this.replicatedLockRecord = new ReplicatedLockRecord();
        this.gameContextData = {};
        this.playerAndGameIdProvider = props.playerAndGameIdProvider;
        this.lobbyDataProvider = props.lobbyDataProvider;
        this.replicatedObjectDataProvider = props.replicatedObjectDataProvider;
    }
    activate() {
        this.gameContextData = Object.assign(Object.assign(Object.assign(Object.assign({}, this.replicatedObjectDataProvider.data), this.playerAndGameIdProvider.data), this.lobbyDataProvider.data), { getReplicatedObjectById: (replicatedObjectId) => this.replicatedObjectDataProvider.getReplicatedObjectById(replicatedObjectId), locks: this.replicatedLockRecord });
    }
    close() { }
    update(inEvent) {
        if (inEvent.type === 'Created' || inEvent.type === 'Updated') {
            this.gameContextData[inEvent.key] = inEvent.newData;
        }
        else {
            if (this.gameContextData[inEvent.key] !== undefined) {
                delete this.gameContextData[inEvent.key];
            }
        }
        return null;
    }
    getLayerData() {
        return this.gameContextData;
    }
}
//# sourceMappingURL=GameContext.js.map